import { addModalToggleClickEvents } from '../modalToggle'
import { addClickEventForBookServiceButton } from './addClickEventForBookServiceButton'
import { addServiceMoreButtonClickEvent } from './addServiceMoreButtonClickEvent'

export function updateRecommendations() {
  const recommendationsContainer = document.querySelector('.recommendations-container');
  let serviceNames = document.querySelector('[name="services"]').value;
  const url = `${location.protocol}//${location.host}`;
  const route = `/recommendations/${encodeURIComponent(serviceNames)}`;
  const fullUrl = `${url}${route}`;

  fetch(fullUrl, {
    method: 'GET',
    headers: {
      'Accept': 'application/javascript'
    }
  })
  .then(response => response.text())
  .then(data => {
    recommendationsContainer.innerHTML = data;
    addClickEventForBookServiceButton();
    addModalToggleClickEvents();
    addServiceMoreButtonClickEvent();
  })
  .catch(error => {
    console.error("There was a problem with the fetch operation:", error);
  });
}
